<template>
  <section>
    <PvCard :class="[cardClass]">
      <template #title>
        <slot name="title">
          <h2 class="mb-3 fs-3">{{ sectionCaption.toLocaleUpperCase() }}</h2>
        </slot>
      </template>
      <template #content>
        <slot name="content"></slot>
      </template>
    </PvCard>  
  </section>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core


// Components


// Composables


// Stores


// Constants and Utils


// ===============================
// PROPS & EMITS
// ===============================
defineProps({
  sectionCaption: {
      type: String,
      default: 'Section Caption'
  },
  cardClass: {
      type: String,
      default: ''
  }
});

// ===============================
// COMPOSABLES & STORES
// ===============================

// ===============================
// REACTIVE STATE
// ===============================

// ===============================
// CONSTANTS
// ===============================

// ===============================
// COMPUTED PROPERTIES
// ===============================

// ===============================
// METHODS
// ===============================

// ===============================
// WATCHERS
// ===============================

// ===============================
// LIFECYCLE HOOKS
// ===============================

// ===============================
// EXPOSE
// ===============================


</script>
